import React from "react";
import { IconSortDescending, IconSortAscending } from "@tabler/icons";
import { TableInstance } from "react-table";
import { DropdownContainer } from "../Dropdown";

export type DataTableHeaderProps<T extends object> = TableInstance<T> & {
  columnFilter?: boolean;
};

export const DataTableHeader = <T extends object>(
  props: DataTableHeaderProps<T>
) => {
  const { columnFilter, headerGroups, ...rest } = props;

  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map((column) => (
            <th key={column.id}>
              <DropdownContainer>
                <div className="header-container">
                  <div
                    className="header-text"
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    {column.render("Header")}
                  </div>
                  <div className="header-item">
                    {column.isSorted && (
                      <span
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        {column.isSortedDesc ? (
                          <IconSortDescending size="1rem" />
                        ) : (
                          <IconSortAscending size="1rem" />
                        )}
                      </span>
                    )}
                  </div>
                  <div className="header-item">
                    {columnFilter &&
                      column.canFilter &&
                      column.render("Filter")}
                  </div>
                </div>
              </DropdownContainer>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};

export default DataTableHeader;
